import axiosInstance from "./axiosInstance";

const unwrapWorklog = (data) => data?.worklog ?? data?.data?.worklog ?? null;

const unwrapWorklogs = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.worklogs)) return data.worklogs;
  if (Array.isArray(data?.data?.worklogs)) return data.data.worklogs;
  if (Array.isArray(data?.data)) return data.data;
  return [];
};

export async function getWorklogs(taskId, options = {}) {
  const { data } = await axiosInstance.get(`/api/task/${taskId}/worklogs`, options);
  return unwrapWorklogs(data);
}

export async function getWorklogById(taskId, worklogId, options = {}) {
  const { data } = await axiosInstance.get(
    `/api/task/${taskId}/worklog/${worklogId}`,
    options
  );
  return unwrapWorklog(data);
}

export async function createWorklog(taskId, payload) {
  const { data } = await axiosInstance.post(`/api/task/${taskId}/worklog`, payload);
  return unwrapWorklog(data);
}

export async function updateWorklog(taskId, worklogId, payload) {
  const { data } = await axiosInstance.put(
    `/api/task/${taskId}/worklog/${worklogId}`,
    payload
  );
  return unwrapWorklog(data);
}

export async function deleteWorklog(taskId, worklogId) {
  const { data } = await axiosInstance.delete(
    `/api/task/${taskId}/worklog/${worklogId}`
  );
  return unwrapWorklog(data);
}
